export default __webpack_public_path__ + "static/media/Usuarios.79d140ba.svg";